import { HTMLAttributes } from 'react';
import { FiX } from 'react-icons/fi';
import { twMerge } from 'tailwind-merge';
import { Heading } from '../../../typography';
import { IsVisible } from '../../../utils';

interface IModalHeaderProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  handleClose?: React.MouseEventHandler<HTMLButtonElement>;
  hideCloseButton?: boolean;
  title?: string;
}

export function ModalHeader({
  className,
  handleClose,
  hideCloseButton = false,
  title,
  ...rest
}: IModalHeaderProps) {
  return (
    <div
      className={twMerge('grid grid-cols-[1fr_auto] px-4 relative', className)}
      {...rest}
    >
      <Heading
        className="text-gray-700 w-full break-words overflow-auto whitespace-normal"
        variant="h5"
      >
        {title}
      </Heading>
      <IsVisible when={!hideCloseButton}>
        <button
          aria-label="Close modal"
          className="bg-transparent text-gray-700 hover:opacity-60"
          onClick={handleClose}
          type="button"
        >
          <FiX size={24} />
        </button>
      </IsVisible>
    </div>
  );
}
